export enum OperationLogSource {
  MANUAL_USER_IMPORT = 'manual-user-import',
  AD_SYNC = 'ad-sync',
  GOOGLE_WORKSPACE_SYNC = 'google-workspace-sync',
}

export enum OperationLogStatus {
  SUCCESS = 'success',
  COMPLETED_WITH_ISSUES = 'completed-with-issues',
  FAILED = 'failed',
}

export type OperationLog = {
  id: string;
  account: { id: string };
  source: OperationLogSource;
  status: OperationLogStatus;
  errorCount: number;
  errors: unknown[];
  created: string;
  updated: string | null;
};

export type OperationLogsResponse = {
  result: OperationLog[];
  count: number;
  fetched: number;
};
